import { useState, useEffect, useRef } from 'react';

// 👇 Add this inside Contact.jsx
const ExpandInput = ({ placeholder, name, required, className = "field" }) => {
  const spanRef = useRef(null);
  const inputRef = useRef(null);
  const [value, setValue] = useState('');

  useEffect(() => {
    const text = value || placeholder || '';
    if (spanRef.current && inputRef.current) {
      spanRef.current.textContent = text;
      inputRef.current.style.width = `${spanRef.current.offsetWidth + 315}px`; // Add slight padding
    }
  }, [value, placeholder]);

  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      <span
        ref={spanRef}
        style={{
          visibility: 'hidden',
          whiteSpace: 'pre',
          fontSize: '1rem',
          fontFamily: 'inherit',
          position: 'absolute',
        }}
      />
      <input
        ref={inputRef}
        type="text"
        name={name}
        required={required}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={className}
        placeholder={placeholder}
      />
    </div>
  );
};

export default ExpandInput;
